export default __webpack_public_path__ + "media/src/assets/images/driver-aec7cdf3a1b009dddaa582941d8b3b10.png";